import Toilets from './ToiletsContainer';

export default Toilets;
